import axios from "axios";
//
// let subdomainUrl =
//   process.env.VUE_APP_API_BASE_URL_FIRST +
//   (localStorage.getItem("city") ? localStorage.getItem("city") + "." : "") +
//   process.env.VUE_APP_API_BASE_URL_SECOND;
export const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
